// service
import AxiosInstanceCreator from 'services/api';

// libraries
import { type AxiosInstance } from 'axios';

export class ImageAPI {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator({}).create();
  }

  /** favicon 이미지 조회 API (.ico 확장자) */
  async getFaviconIco(): Promise<Blob> {
    return await this.Axios.get<Blob>('/img/favicon.ico', {
      responseType: 'blob'
    }).then((res) => res.data);
  }

  /** favicon 이미지 조회 API */
  async getFavicon(): Promise<Blob> {
    return await this.Axios.get<Blob>('/img/favicon', {
      responseType: 'blob'
    }).then((res) => res.data);
  }

  /** CI 이미지 조회 API */
  async getCI() {
    return await this.Axios.get('/img/ci', {
      responseType: 'blob',
      headers: {
        'Content-Type': 'image/jpeg;charset=UTF-8, application/octet-stream; charset=UTF-8'
      }
    }).then((res) => res.data);
  }
}
